var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelectComponent',{attrs:{"value":_vm.value,"options":_vm.villageOptions,"placeholder":"Kampung"},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }